<div class="sidebar" [class.collapsed]="isCollapsed" [attr.data-modo]="modo">
  <div class="sidebar-header">
    <span class="logo" title="Institucional">
      <img src="../../../../assets/images/logo-sai.png" class="img-fluid" alt="SAI">
    </span>
    <span class="title" *ngIf="exibirRotulos">Institucional</span>

    <button
      class="toggle-btn"
      *ngIf="podeAlternar"
      type="button"
      [title]="isCollapsed ? 'Abrir menu' : 'Recolher menu'"
      [attr.aria-label]="isCollapsed ? 'Abrir menu' : 'Recolher menu'"
      (click)="alternarSidebar()"
      [attr.aria-expanded]="!isCollapsed">
      <i-lucide name="menu" color="#fff"></i-lucide>
    </button>
  </div>

  <nav class="menu">
    <ng-container *ngFor="let item of menuItems">
      <a *ngIf="!item.children" class="menu-item" [routerLink]="item.route" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: item.exact || false }" [title]="item.label">
        <i-lucide [name]="item.icon" [title]="item.label"></i-lucide>
        <span *ngIf="exibirRotulos">{{ item.label }}</span>
      </a>

      <div *ngIf="item.children" class="menu-group" [class.active-group]="itemAtivo(item)">
        <button type="button" class="menu-item menu-group-title" (click)="alternarItem(item)"
          [title]="item.label" [attr.aria-expanded]="item.expanded || false">
          <i-lucide [name]="item.icon" [title]="item.label"></i-lucide>
          <span *ngIf="exibirRotulos">{{ item.label }}</span>
          <i-lucide *ngIf="exibirRotulos" class="menu-chevron"
            [name]="item.expanded ? 'chevron-up' : 'chevron-down'"></i-lucide>
        </button>

        <div class="submenu" *ngIf="item.expanded">
          <a *ngFor="let filho of item.children" class="submenu-item" [class.disabled]="filho.disabled"
            [routerLink]="filho.disabled ? null : filho.route" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: filho.exact || false }" [title]="filho.label"
            [attr.aria-disabled]="filho.disabled || null">
            <i-lucide *ngIf="!exibirRotulos || modo === 'mobile'" [name]="filho.icon" size="18"></i-lucide>
            <span *ngIf="exibirRotulosSubmenu">{{ filho.label }}</span>
          </a>
        </div>
      </div>
    </ng-container>
  </nav>
</div>
